var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#DCD6CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9264 4.34926C13.4742 3.9038 12.8646 3.65476 12.2299 3.65626C11.5858 3.65626 10.9862 3.90376 10.5334 4.34926L4.98937 9.80888C4.96142 9.83694 4.9397 9.87058 4.92564 9.90761C4.91159 9.94464 4.90551 9.98422 4.90781 10.0238V12.834L3.375 14.3438H4.22044L5.35556 13.2261H8.19281C8.23264 13.2265 8.27211 13.2186 8.30872 13.2029C8.34532 13.1872 8.37826 13.1641 8.40544 13.1349L13.9213 7.70232L13.9269 7.69669C14.1476 7.47925 14.323 7.22016 14.4428 6.93445C14.5626 6.64874 14.6246 6.34208 14.625 6.03226C14.6265 5.7195 14.5655 5.4096 14.4455 5.12077C14.3256 4.83193 14.149 4.57001 13.9264 4.35038V4.34926ZM10.7021 4.98376L10.9367 4.75313C11.2812 4.4136 11.7462 4.2243 12.2299 4.22663C12.7153 4.22663 13.1737 4.41451 13.5231 4.75313C13.5287 4.75876 13.5343 4.76888 13.545 4.77451C13.8774 5.11313 14.0574 5.55357 14.0574 6.02663C14.0574 6.50476 13.8662 6.95588 13.5231 7.30013L13.2829 7.53638H11.1386L12.5466 6.14982C12.6004 6.09727 12.6316 6.02581 12.6336 5.95061C12.6356 5.87541 12.6082 5.8024 12.5573 5.74707C12.5516 5.74144 12.5516 5.73582 12.546 5.73076C12.4896 5.67664 12.4144 5.64643 12.3362 5.64643C12.258 5.64643 12.1828 5.67664 12.1264 5.73076L10.7077 7.12801V4.98319L10.7021 4.98376ZM5.93438 12.6568L7.09087 11.5172H9.23512L8.07863 12.6568H5.93438ZM9.30037 9.33582L10.6701 7.98694H12.8143L11.4446 9.33582H9.30037ZM10.9755 9.79819L9.69863 11.0554H7.55438L8.83125 9.79819H10.9755ZM8.86444 6.79444L10.2392 5.43994V7.57857L8.86444 8.93813V6.79444ZM7.11844 8.51344L8.39531 7.25626V9.39488L7.11844 10.6521V8.51344ZM5.48156 10.1256L6.65438 8.97582V11.1144L5.48156 12.2642V10.1256Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoe);
export default __webpack_public_path__ + "static/media/poe.8570aabf63e9df2d1cc92759d7047407.svg";
export { ForwardRef as ReactComponent };